import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Programme from "./pages/Programme";
import Actualites from "./pages/Actualites";
import ArticleDetail from "./pages/ArticleDetail";
import Videos from "./pages/Videos";
import Contact from "./pages/Contact";
import EnvoiVideo from "./pages/EnvoiVideo";
import Lettre from "./pages/Lettre";
import ProfessionDeFoi from "./pages/ProfessionDeFoi";
import Stats from "./pages/Stats";
import axios from "axios";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.pointerEvents = "";
    document.body.style.overflow = "";
    let visitor = localStorage.getItem("af_visitor");
    if (!visitor) {
      visitor = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("af_visitor", visitor);
    }
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/track`, { page: pathname, visitor }).catch(() => {});
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programme" element={<Programme />} />
            <Route path="/actualites" element={<Actualites />} />
            <Route path="/actualites/:slug" element={<ArticleDetail />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/envoi-video" element={<EnvoiVideo />} />
            <Route path="/lettre" element={<Lettre />} />
            <Route path="/profession-de-foi" element={<ProfessionDeFoi />} />
            <Route path="/stats" element={<Stats />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
